import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './routers/index'
import i18n from './plugins/i18n'
import api from './service/api'
import Video from 'video.js'
import axios from 'axios'
import './components/index'
import './util/filter'
import './plugins/iview'
import '../theme/index.less'
import './styles/app.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'video.js/dist/video-js.css'


Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper, /* { default global options } */);
// Vue.use(MetaInfo);
Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$video = Video;
Vue.prototype.$imgHost = process.env.VUE_APP_imgHost;

const lang = localStorage.getItem('locale') || 'zh';
store.commit('base/setLanguage', lang);


new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');